import {ObjUtil} from 'yougile-util'
import {
  Hub,
  noBoardContainerId,
  SandboxTree,
  systemStickers,
  TaskDataService
} from 'yougile-model'
import {Sync} from '@client/sync'
import {stickerCtl} from './sticker/sticker'
import {Task} from './task'

export const makeTaskDataService = (box: SandboxTree): TaskDataService => {
  return new TaskDataService(
    id => Task.getById(id),
    id => box.isDeleted(id),
    () => {
      return ObjUtil.map(systemStickers, k => {
        return stickerCtl[k].getSticker(box).id
      })
    }
  )
}

export const getTaskBoard = (task: Hub): Hub | undefined => {
  if (!task) {
    return undefined
  }

  if (task.location === noBoardContainerId) {
    return undefined
  }

  const box = Sync.getCurrentSandbox()
  const column = box.get(task.location)
  if (!column) {
    return undefined
  }

  const boardId = column.location
  if (boardId === noBoardContainerId) {
    return undefined
  }
  return box.getHub(boardId)
}
